import { DragGesture } from "../../gestures/drag";
import { PanGesture } from "../../gestures/pan";
import { HTMLProjectionNode } from "../../projection";
import { MeasureLayout } from "./layout/MeasureLayout";
export const drag = {
    pan: {
        Feature: PanGesture,
    },
    drag: {
        Feature: DragGesture,
        ProjectionNode: HTMLProjectionNode,
        MeasureLayout,
    },
};
//# sourceMappingURL=drag.js.map